import varAxios from "../../Comman/axios";
import {GetRegionListUrl,getAlarmFieldsUrl, updateAlarmFieldUrl, getFreeTextDescriptionListUrl} from '../../Comman/apiEndPoints'; 

export const GET_ALARM_FIELDS_REQUEST = "GET_ALARM_FIELDS_REQUEST";
export const GET_ALARM_FIELDS_SUCCESS = "GET_ALARM_FIELDS_SUCCESS";
export const UPDATE_ALARM_FIELDS_SUCCESS = "UPDATE_ALARM_FIELDS_SUCCESS";
export const GET_PREDEFINED_TEXT_LIST_SUCCESS = "GET_PREDEFINED_TEXT_LIST_SUCCESS";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";
export function getAlarmFields(RegionId) {
    return (dispatch) => {
      dispatch(getAlarmFieldsRequest(true)); 
        return varAxios.post(getAlarmFieldsUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                getAlarmFieldsSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.alarmDataVisibilityList)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function getAlarmFieldsRequest(isLoading){
    return {
      type : GET_ALARM_FIELDS_REQUEST,
      isLoading
    }
  }
  export function getAlarmFieldsSuccess(isLoading,errorCode, statusCode, list){
    return {
      type : GET_ALARM_FIELDS_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      list
    }
  }

  export function updateAlarmFieldFunc(payload) {
    return (dispatch) => {
      dispatch(getAlarmFieldsRequest(true)); 
        return varAxios.post(updateAlarmFieldUrl, payload)
            .then((response) => {
              dispatch(
                updateAlarmFieldsSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.alarmDataVisibilityList, response.data.Message)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function updateAlarmFieldsSuccess(isLoading,errorCode, statusCode, list, message){
    return {
      type : UPDATE_ALARM_FIELDS_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      list,
      message
    }
  }
  export function getPredefinedTextListFunc(RegionId) {
    return (dispatch) => {
      dispatch(getAlarmFieldsRequest(true)); 
        return varAxios.post(getFreeTextDescriptionListUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                getPredefinedTextListSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.freeFextDescriptionList)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function getPredefinedTextListSuccess(isLoading,errorCode, statusCode, list){
    return {
      type : GET_PREDEFINED_TEXT_LIST_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      list
    }
  }
  export function getAllRegionSettings() {
      let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        this.getAlarmFields({RegionId:response.data.regionList[0].ID});
        this.getPredefinedTextListFunc({RegionId:response.data.regionList[0].ID})
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}